import { render } from "./LoadingIndicator.vue?vue&type=template&id=008e12b7"
import script from "./LoadingIndicator.vue?vue&type=script&lang=js"
export * from "./LoadingIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__